/*
 * Lucide auto-alojado, servido desde el bundle del theme.
 *
 * Antes se cargaba el UMD completo desde unpkg con la etiqueta "latest": era una
 * petición a un tercero que bloqueaba el render y, al no fijar versión, dejaba
 * al azar del CDN qué código se ejecutaba en producción.
 *
 * Aquí se importan solo los iconos que el theme usa de verdad y se expone el
 * mismo objeto global `lucide` que ya esperan los puntos de llamada existentes,
 * para que ninguno tenga que cambiar.
 *
 * Al añadir un `data-lucide` nuevo en una plantilla hay que añadir su icono a
 * este mapa: los que falten no dan error, simplemente no se pintan.
 */
import {
    createIcons,
    ArrowLeft,
    ArrowRight,
    ArrowUpRight,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronsUpDown,
    CircleAlert,
    Clock2,
    CornerDownRight,
    Dot,
    Handbag,
    Info,
    MapPin,
    Minus,
    MoveLeft,
    MoveRight,
    Navigation,
    Plus,
    Search,
    Slash,
    Trash,
    UserRound,
    X,
    ZoomIn,
} from 'lucide';

const icons = {
    ArrowLeft,
    ArrowRight,
    ArrowUpRight,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronsUpDown,
    CircleAlert,
    Clock2,
    CornerDownRight,
    Dot,
    Handbag,
    Info,
    MapPin,
    Minus,
    MoveLeft,
    MoveRight,
    Navigation,
    Plus,
    Search,
    Slash,
    Trash,
    UserRound,
    X,
    ZoomIn,
};

/* El UMD de lucide aceptaba opciones en createIcons; se respeta esa firma y solo
   se inyecta el mapa de iconos, que es lo que el build con tree-shaking no puede
   resolver solo. */
window.lucide = {
    createIcons: (options = {}) => createIcons({ icons, ...options }),
};
